import { FC, ReactElement } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { CssBaseline, StyledEngineProvider } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { defaultTheme } from 'assets/themes'
import { toastsProps } from 'constants/toasts'
import { store } from 'store'

/**
 * Wraps Component into providers
 * @param Component Component
 * @returns Wrapped Component
 */
export function withProviders<T = any>(Component: FC<T>) {
  return (props: JSX.IntrinsicAttributes & T): ReactElement => (
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={defaultTheme}>
          <StyledEngineProvider injectFirst>
            <CssBaseline />
            <Component {...props} />
            <ToastContainer {...toastsProps} />
          </StyledEngineProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  )
}
